import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { logoutUser, findUser, getNotif } from '../store/actions/userAction'
import { fetchApps } from '../store/actions/appAction'
import Collapse from '@material-ui/core/Collapse';
import { Grid } from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import FeatureList from './FeatureList'
import HomeIcon from '@material-ui/icons/Home';
import AppsIcon from '@material-ui/icons/Apps';
import { BsFillGridFill } from "react-icons/bs"
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AppBar from '@material-ui/core/AppBar';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MoreIcon from '@material-ui/icons/MoreVert';
import NotificationsPopover from './notification/NotificationsPopover';
import PodcastsIcon from '@mui/icons-material/Podcasts';
import SupervisorAccountSharpIcon from '@mui/icons-material/SupervisorAccountSharp';
import SettingsIcon from '@mui/icons-material/Settings';
import env from '../env'

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      zIndex: "9999",
      boxShadow: "none"
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

function MenuBar(props) {
  const history = useHistory()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchApps())
    dispatch(findUser())
    dispatch(getNotif())
  }, [dispatch])

  const apps = useSelector(state => state.appReducer.apps)
  const user = useSelector(state => state.userReducer.userLogin)
  // const notif = useSelector(state => state.userReducer.notif)
  // const packages = useSelector(state => state.userReducer.package)
  // const error = useSelector(state => state.appReducer.error)

  const app = {}
  for (let i = 0; i < apps.length; i++) {
    app[`app_${apps[i]._id}`] = false    
  }

  const [openApp, setOpenApp] = useState(false);
  const [openAppDetail, setOpenAppDetail] = useState(app);
  const [openBroadacastMenu, setOpenBroadcastMenu] = useState(false);
  const [openAdmMenu, setOpenAdmMenu] = useState(false);
  const [isSuperAdm, setIsSuperAdm] = useState(false);

  useEffect(() => {
    if (user.email === env.SUPERADM) {
      setIsSuperAdm(true)
    }
  }, [user])

  const handleListAppClick = () => {
    setOpenApp(!openApp);
  };

  const handleBroadcastMenu = () => {
    setOpenBroadcastMenu(!openBroadacastMenu)
  }

  const handleAdmMenu = () => {
    setOpenAdmMenu(!openAdmMenu)
  }

  const handleHome = () => {
    history.push('/app')
  }

  const handleLogout = () => {
    dispatch(logoutUser())
    history.push('/')
  }

  const handleOpenDetailApp = (id) => {
    let bool;
    if (openAppDetail[`app_${id}`]) {
      bool = false
    } else {
      bool = true      
    }
    setOpenAppDetail({...openAppDetail, [`app_${id}`]: bool});
  }

  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [notifEl, setNotifEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const isNotifOpen = Boolean(notifEl);

  const handleProfileMenuOpen = (event) => {
    setNotifEl(null);
    setAnchorEl(event.currentTarget);
  };

  const handleNotifOpen = (event) => {
    setAnchorEl(null);
    setNotifEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setNotifEl(null);
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleProfilePage = () => {
    history.push('/profile')
  }

  const handleTemplate = () => {
    history.push('/broadcast/template')
  }

  const handleContactGroup = () => {
    history.push('/broadcast/group')
  }

  const handleReport = () => {
    history.push('/broadcast/report')
  }

  const handleConfig = () => {
    history.push('/broadcast/config')
  }

  const handleContactUsList = () => {
    history.push('/admin/contactUs')
  }

  const handleTemplateSubmission = () => {
    history.push('/admin/templateSubmission')
  }

  const drawer = (
    <div>
      <div className="scrollbar" id="style-1">
        <div className="force-overflow"></div>
      </div>
      <div className={classes.toolbar} />
      <List>
      <ListItem button onClick={handleHome}>
        <span className="reguler"><HomeIcon style={{marginTop: "-3px"}}/> Beranda</span>
      </ListItem>
      <ListItem button onClick={handleListAppClick}>
         <span className="reguler"><AppsIcon style={{marginTop: "-3px"}}/> Aplikasi Login</span>
      </ListItem>
      <Collapse in={openApp} timeout="auto" unmountOnExit style={{paddingLeft: "1.6rem"}}>
        <List component="div" disablePadding>
            {
              apps.map(app => {
                return (
                  <>                  
                    <ListItem button key={app._id} className={classes.nested} onClick={() => handleOpenDetailApp(app._id)}>
                      <Grid container>
                          <Grid item style={{width: "100%", display: "flex"}}>
                            <ListItemText>
                              <BsFillGridFill style={{marginTop: "-3px"}}/>
                              <span className="reguler"> {app.appName}</span>
                            </ListItemText>
                            {
                              openAppDetail[`app_${app._id}`] ?
                              <ExpandLess style={{marginTop: "3px"}}/>
                              :
                              <ExpandMore style={{marginTop: "3px"}}/>
                            }      
                          </Grid>                        
                      </Grid>
                    </ListItem>    
                      <Grid container>
                          {
                            openAppDetail[`app_${app._id}`] &&
                              <FeatureList key={app._id} appId={app._id}/>
                          }
                      </Grid>
                  </>
                )
              })
            }
        </List>
      </Collapse>
      <ListItem button onClick={handleBroadcastMenu}>
         <span className="reguler"><PodcastsIcon style={{marginTop: "-3px"}}/> Siaran</span>
      </ListItem>
      <Collapse in={openBroadacastMenu} timeout="auto" unmountOnExit style={{paddingLeft: "1.6rem"}}>
        <List component="div" disablePadding>
          <ListItem button key={app._id} className={classes.nested} onClick={() => handleTemplate()}>
            <Grid container>
              <Grid item style={{width: "100%", display: "flex"}}>
                <ListItemText>
                    <span className="reguler font-size-14"> Template </span>
                </ListItemText>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem button key={app._id} className={classes.nested} onClick={() => handleContactGroup()}>
            <Grid container>
              <Grid item style={{width: "100%", display: "flex"}}>
                <ListItemText>
                  {/* <BsFillGridFill style={{marginTop: "-3px"}}/> */}
                    <span className="reguler font-size-14"> Grup Kontak </span>
                </ListItemText>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem button key={app._id} className={classes.nested} onClick={() => handleReport()}>
            <Grid container>
              <Grid item style={{width: "100%", display: "flex"}}>
                <ListItemText>
                    <span className="reguler font-size-14"> Report </span>
                </ListItemText>
              </Grid>
            </Grid>
          </ListItem>        
        </List>
      </Collapse>
      <ListItem button onClick={handleConfig}>
        <span className="reguler"><SettingsIcon style={{marginTop: "-3px"}}/> Pengaturan</span>
      </ListItem>
      {
        isSuperAdm &&
        <div>
          <ListItem button onClick={handleAdmMenu}>
            <span className="reguler"><SupervisorAccountSharpIcon style={{marginTop: "-3px"}}/> Administrator </span>
          </ListItem>
          <Collapse in={openAdmMenu} timeout="auto" unmountOnExit style={{paddingLeft: "1.6rem"}}>
            <List component="div" disablePadding>
              <ListItem button key={app._id} className={classes.nested} onClick={() => handleContactUsList()}>
                <Grid container>
                  <Grid item style={{width: "100%", display: "flex"}}>
                    <ListItemText>
                        <span className="reguler font-size-14"> Contact Us List </span>
                    </ListItemText>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem button key={app._id} className={classes.nested} onClick={() => handleTemplateSubmission()}>
                <Grid container>
                  <Grid item style={{width: "100%", display: "flex"}}>
                    <ListItemText>
                      {/* <BsFillGridFill style={{marginTop: "-3px"}}/> */}
                        <span className="reguler font-size-14"> Template Submission </span>
                    </ListItemText>
                  </Grid>
                </Grid>
              </ListItem>
            </List>
          </Collapse>

        </div>
      }
      <ListItem button onClick={handleLogout}>
            <span className="reguler"><ExitToAppIcon style={{marginTop: "-3px"}}/> Keluar</span>
      </ListItem>
    </List>
    </div>
  );

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      style={{zIndex: "9999", top: "35px"}}
    >
      <MenuItem className="font-size-14 text-darkgrey reguler py-2 pr-30 pl-10" onClick={handleMenuClose}>Hallo, {user.name? user.name : user.email ? user.email : user.phone}</MenuItem>
      <hr style={{margin: "0 10px"}}/>
      <MenuItem className="font-size-14 text-darkgrey reguler py-2 pr-30 pl-10" onClick={handleProfilePage}>Profile</MenuItem>
      <hr style={{margin: "0 10px"}}/>
      <MenuItem className="font-size-14 text-darkgrey reguler py-2 pr-30 pl-10" onClick={handleLogout}>Logout</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton>
          <Typography>
            <a href='https://quickey-docs.netlify.app'>
            Dokumentasi
            </a>
            </Typography>
        </IconButton>
      </MenuItem>
      {/* <MenuItem>
        <IconButton>
          <Typography>FAQ</Typography>
        </IconButton>
      </MenuItem> */}
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.root}>
      <div>
        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar className="d-flex" style={{justifyContent: "space-between", backgroundColor: "rgb(31 31 31)"}}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap>
              <img className="d-flex" width="125px" src="/quickey-beta-white.png" alt="logo quickey beta"/>
            </Typography>
            <div className={classes.grow} />
            <div className={classes.sectionDesktop}>
              <IconButton>
              <Typography>
                <a href='https://quickey-docs.netlify.app'>
                  Dokumentasi
                </a>
              </Typography>
              </IconButton>
              {/* <IconButton>
              <Typography className="font-size-14 reguler" style={{color: "#f1f1f1"}}>FAQ</Typography>
              </IconButton> */}
              {/* <IconButton
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleNotifOpen}
                color="inherit">
                <Badge badgeContent={0} color="secondary">
                  <NotificationsIcon />
                </Badge>
              </IconButton> */}
              <NotificationsPopover style={{zIndex:'999999'}}/>
              <IconButton
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
            </div>
            <div className={classes.sectionMobile}>
              <IconButton
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MoreIcon />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        {renderMobileMenu}
        {renderMenu}
      </div>
      <nav className={classes.drawer} aria-label="mailbox folders">
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true,
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
    </div>
  );
}


export default MenuBar;